function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 14,
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.7857 26.875C16.7857 27.1734 16.9099 27.4595 17.1309 27.6705C17.3519 27.8815 17.6517 28 17.9643 28H25.0357C25.3483 28 25.6481 27.8815 25.8691 27.6705C26.0901 27.4595 26.2143 27.1734 26.2143 26.875V19H16.7857V26.875ZM23.4643 20.875C23.4643 20.7755 23.5057 20.6802 23.5793 20.6098C23.653 20.5395 23.7529 20.5 23.8571 20.5C23.9613 20.5 24.0613 20.5395 24.1349 20.6098C24.2086 20.6802 24.25 20.7755 24.25 20.875V26.125C24.25 26.2245 24.2086 26.3198 24.1349 26.3902C24.0613 26.4605 23.9613 26.5 23.8571 26.5C23.7529 26.5 23.653 26.4605 23.5793 26.3902C23.5057 26.3198 23.4643 26.2245 23.4643 26.125V20.875ZM21.1071 20.875C21.1071 20.7755 21.1485 20.6802 21.2222 20.6098C21.2959 20.5395 21.3958 20.5 21.5 20.5C21.6042 20.5 21.7041 20.5395 21.7778 20.6098C21.8515 20.6802 21.8929 20.7755 21.8929 20.875V26.125C21.8929 26.2245 21.8515 26.3198 21.7778 26.3902C21.7041 26.4605 21.6042 26.5 21.5 26.5C21.3958 26.5 21.2959 26.4605 21.2222 26.3902C21.1485 26.3198 21.1071 26.2245 21.1071 26.125V20.875ZM18.75 20.875C18.75 20.7755 18.7914 20.6802 18.8651 20.6098C18.9387 20.5395 19.0387 20.5 19.1429 20.5C19.247 20.5 19.347 20.5395 19.4206 20.6098C19.4943 20.6802 19.5357 20.7755 19.5357 20.875V26.125C19.5357 26.2245 19.4943 26.3198 19.4206 26.3902C19.347 26.4605 19.247 26.5 19.1429 26.5C19.0387 26.5 18.9387 26.4605 18.8651 26.3902C18.7914 26.3198 18.75 26.2245 18.75 26.125V20.875ZM26.6071 16.75H23.6607L23.4299 16.3117C23.381 16.218 23.3057 16.1392 23.2124 16.0841C23.1192 16.0291 23.0117 15.9999 22.902 16H20.0955C19.9861 15.9996 19.8788 16.0286 19.7859 16.0838C19.6929 16.1389 19.6182 16.2179 19.5701 16.3117L19.3393 16.75H16.3929C16.2887 16.75 16.1887 16.7895 16.1151 16.8598C16.0414 16.9302 16 17.0255 16 17.125V17.875C16 17.9745 16.0414 18.0698 16.1151 18.1402C16.1887 18.2105 16.2887 18.25 16.3929 18.25H26.6071C26.7113 18.25 26.8113 18.2105 26.8849 18.1402C26.9586 18.0698 27 17.9745 27 17.875V17.125C27 17.0255 26.9586 16.9302 26.8849 16.8598C26.8113 16.7895 26.7113 16.75 26.6071 16.75Z",
  fill: "#FF8D10"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd",
  x: -6,
  y: 2,
  width: 56,
  height: 48,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4,
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4,
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.160784 0 0 0 0 0.176471 0 0 0 0 0.184314 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  fill: "white"
})));

const SvgTrash = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash.7fe3336e.svg";
export { ForwardRef as ReactComponent };